module.exports = __webpack_public_path__ + "static/media/bannerImage3-l.031eb2d9.jpg";